import { Navigate } from 'react-router-dom';
import { useRootSelector } from '@/hooks/selector.hook';
import { useLoadingGif } from '@/hooks/loadingGif.hook';

/**
 * SmartRedirect
 *
 * Redirects the user to the first module they have permission to access,
 * based on the sidebar navigation data returned from the API.
 *
 * This replaces the hardcoded `<Navigate to="/stores" />` to avoid
 * auto-navigating into a module the user may not have access to.
 */
export const SmartRedirect = () => {
  const { dataSidebar } = useRootSelector((state) => state.sidebar);
  const LoadingGif = useLoadingGif();

  const firstNavItem = dataSidebar?.navigation?.[0];

  // Sidebar data hasn't loaded yet — show loading spinner
  if (!firstNavItem) {
    return (
      <div className="flex items-center justify-center w-full h-screen bg-main">
        <img src={LoadingGif} alt="Loading" className="w-[8rem] h-[8rem] opacity-70" />
      </div>
    );
  }

  // Redirect to the first accessible module
  return <Navigate to={firstNavItem.url} replace />;
};
